const STORAGE_KEY = 'shop_items_cache';

export function saveItemsToCache(items, count, page, filters) {
  if (!Array.isArray(items)) return;

  const payload = {
    items,
    count,
    page: page || 0,
    filters: filters || {},
    savedAt: Date.now(),
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // localStorage can be disabled or full
  }
}

/**
 * Returns cached items if available and filters match.
 * @param {Object} currentFilters - Current filters to compare with cached filters.
 * @returns {Object|null} - Cached payload with items and filters, or null
 */
export function loadItemsFromCache(currentFilters) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const payload = JSON.parse(raw);
    if (!payload || !Array.isArray(payload.items)) return null;

    // Check if cache is older than 1 hour
    if ((Date.now() - payload.savedAt) > 3600000) {
      return null;
    }

    // Check if filters match
    if (!areFiltersEqual(payload.filters || {}, currentFilters || {})) {
      return null;
    }

    return payload;
  } catch (e) {
    return null;
  }
}

export function clearItemsCache() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // localStorage can be disabled
  }
}

// Determine if two filter objects are equal
function areFiltersEqual(a, b) {
  const aKeys = Object.keys(a || {});
  const bKeys = Object.keys(b || {});
  if (aKeys.length !== bKeys.length) return false;

  for (const key of aKeys) {
    const aVal = a[key];
    const bVal = b[key];

    // Handle array values
    if (Array.isArray(aVal) && Array.isArray(bVal)) {
      if (aVal.length !== bVal.length) return false;
      // The order of elements matters
      for (let i = 0; i < aVal.length; i++) {
        if (aVal[i] !== bVal[i]) return false;
      }
      continue;
    }

    if (aVal !== bVal) return false;
  }

  return true;
}
